import { Separator } from '@volue/wave-react';
import React from 'react';

import useFeatureToggles from '@/common/hooks/feature-toggles';
import { useAppState } from '@/overmind';

import { ApplicationVersionLabel } from './ApplicationVersionLabel';

export function ApplicationVersionSection(props: { isVisible: boolean }) {
  const { isShowingApplicationVersionEnabled } = useFeatureToggles();
  const config = useAppState().config;
  if (!isShowingApplicationVersionEnabled()) return null;
  if (config.type === 'NOT_AVAILABLE') return null;
  if (!props.isVisible) return null;
  return (
    <nav className="pHm h100">
      <Separator />
      <div className="pTs">
        <ApplicationVersionLabel version={config.config.appVersion} />
      </div>
    </nav>
  );
}
